import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
const loaded = new Map();

/** A component from a lazy chunk, drawn once the chunk has arrived. */
export default class Mount extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    if (!loaded.has(this.attrs.name)) {
      this.attrs.load().then(module => {
        loaded.set(this.attrs.name, module.default);
        m.redraw();
      });
    }
  }
  view() {
    const Loaded = loaded.get(this.attrs.name);
    return Loaded ? m(Loaded, this.attrs.attrs) : m(LoadingIndicator, {
      display: "block"
    });
  }
}
flarum.reg.add('ernestdefoe-shutter', 'forum/components/Mount', Mount);